"use strict";
var processInclude = require("base/util");

function handleTopFilter() {
    var heightHeader = $('.header_block').outerHeight() - 2 + 'px';
    if ($(window).width() < 768) {
        heightHeader = '';
    }
    $('.sticky-pc').css('top', heightHeader);
};
$(document).ready(function () {
    processInclude(require('./to-top'));
    processInclude(require("./header"));
    processInclude(require('./redirectBack'));
    processInclude(require("./components/search"));
    processInclude(require("./components/slick"));
    processInclude(require("./aos"));
    var $maincontent = $('#maincontent');
    var merchant_id = $maincontent.data('merchant-id');
    const ss_external = { user_id: $maincontent.data('user-id'), session_id: $maincontent.data('session-id') };
    staffStart.external.sendTrackingRequest(merchant_id, ss_external);
    $('#maincontent').each(function () {
        var $columns = $('.step__item', this);
        var maxHeight = Math.max.apply(Math, $columns.map(function () {
            return $(this).height();
        }).get());
        $columns.height(maxHeight);
    });
    setTimeout(function () {
        $('.home_page.store_page').css('visibility', 'visible');
    }, 500);
});

window.addEventListener("beforeunload", function () {
    $(".wrap-carousel").removeClass('wrap-carousel-h-auto');
});

$(window).on('load', function () {
    $(".wrap-carousel").addClass('wrap-carousel-h-auto');
    $(".section_top_banner").addClass('loaded');
});

$(window).resize(function () {
    handleTopFilter();
});

$(window).on('scroll', function () {
    handleTopFilter();
});

//sitemap page
function handleCategory(className, classAppend) {
    var getLengthCategoryItems = Math.round($(`.${className}  .sitemap_link`).length/2);
    var flag = false;
    $(`.${className} .sitemap_link`).each(function(index, item){
        if (index >= getLengthCategoryItems + 5 ) {
            if ($(item).prev(".title_grandCategory").length > 0) flag = true;
            if (flag) {
                $(item).prev(".title_childCategory").detach().appendTo(`.${classAppend}`);
                $(item).prev(".title_grandCategory").detach().appendTo(`.${classAppend}`);
                $(item).appendTo(`.${classAppend}`);
            }
        }
    });
}

function handleBrand() {
    $('.box_brand').each(function() {
        var count = $(this).find('.sitemap_link_brand').length;
        if (count > 0) {
            if (count % 3 === 2) {
                $(this).append('<p class="sitemap_link_brand pc-display"></p>');
            } else if (count % 3 === 1) {
                $(this).append('<p class="sitemap_link_brand pc-display"></p><p class="sitemap_link_brand pc-display"></p>');
            }
        } else {
            $(this).remove();
        }
    });
}

if ($(window).width() > 768) {
    handleCategory('box_women', 'box_women_append');
    handleCategory('box_men', 'box_men_append');
    handleBrand();
}

function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

var sort = getCookie('sort') ? getCookie('sort') : 'score';
var stock_none = getCookie('stock_none') ? getCookie('stock_none') : 0;
var grouping = getCookie('grouping') ? getCookie('grouping') : 1;
var size = getCookie('size') ? getCookie('size') : 90;

function isValidURL(string) {
    try {
        new URL(string);
        return true;
    } catch (err) {
        return false;
    }
}

function setNewURL (className, param = '') {
    var listLinkTag = $(className).find('a');
    if (listLinkTag && listLinkTag.length > 0) {
        //Set url for each <a> tag found seperately
        for (var i = 0; i < listLinkTag.length; i++) {
            var aTag = listLinkTag[i];
            var href = $(aTag).attr('href');
            if (!href) { continue; }

            var domainLink = true;
            if (!isValidURL(href)) {
                href = window.location.origin + href;
                domainLink = false;
            }
            var url = new URL(href);
            var searchParams = new URLSearchParams(url.search);
            if (!searchParams.has('sort')) searchParams.set('sort', sort);
            if (!searchParams.has('grouping')) searchParams.set('grouping', grouping);
            if (!searchParams.has('stock_none')) searchParams.set('stock_none', stock_none);
            if (!searchParams.has('size')) searchParams.set('size', size);
            if (param) {
                searchParams.delete('tmlwBrands'); 
            }

            // Convert URLSearchParams to a properly encoded query string
            var stringParams = [...searchParams.entries()]
                .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                .join('&');

            domainLink = domainLink ? url.origin : '';
            var newUrl = domainLink + url.pathname + '?' + stringParams + param;
            $(aTag).attr('href', newUrl);
        }
    }
}

$(document).ready(function () {
    // handle set parameter via cookie redirect PLP
    $(".page_tmlmwwm .brand_3").each(function() {
        setNewURL(this, '&tmlwBrands');
    });

    var selector = ['.hamburger_new_arrival', 
        ' .hamburger_special_products', 
        ' .brand_b .section_brand_b', 
        ' #women_site_content .first_box_five .sitemap_link', 
        ' #women_site_content .no_title_content .sitemap_link', 
        ' .category_galerievie .square_3_box .square_2_img', 
        ' .hamburger_preorder_products', 
        ' .brand-home-page', 
        ' .pre-order-button', 
        ' .new-arrival-button', 
        ' .store-page', 
        ' .discount-shipping', 
        ' .button-recommend', 
        ' .view_all-good-wear', 
        ' .view_all-edition',
        ' .hamburger_menu_sale_women',
        ' .hamburger_menu_sale_men'];
    var $all = $(selector.join(', '));
    $all.each(function() {
        setNewURL(this);
    });
});